import { useState, useEffect, useCallback } from 'react';
import { useStyletron } from 'baseui';

export const useDisplayResponsive = () => {
  const [, theme] = useStyletron();
  const [isMobile, setIsMobile] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    if (!theme) return;
    const checkIsMobile = () => {
      if (theme.breakpoints) setIsMobile(window.innerWidth < theme.breakpoints.large);
    };
    const checkIsPortrait = (e) => {
      if (e && e.matches !== undefined) setIsPortrait(e.matches);
      else if (typeof window.matchMedia === 'function') setIsPortrait(window.matchMedia("(orientation: portrait)").matches);
    };

    checkIsMobile();
    // Initial portrait check
    if (typeof window.matchMedia === 'function') {
      setIsPortrait(window.matchMedia("(orientation: portrait)").matches);
    }

    if (typeof window.matchMedia === 'function') {
      const mql = window.matchMedia("(orientation: portrait)");
      if (mql) {
        mql.addEventListener('change', checkIsPortrait);
        window.addEventListener('resize', checkIsMobile);
        return () => {
          window.removeEventListener('resize', checkIsMobile);
          mql.removeEventListener('change', checkIsPortrait);
        };
      }
    }
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, [theme]);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    const handleFsChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', handleFsChange);
    return () => {
      clearInterval(timer);
      document.removeEventListener('fullscreenchange', handleFsChange);
    };
  }, []);

  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(() => { });
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }, []);

  return {
    isMobile,
    isPortrait,
    isFullscreen,
    currentTime,
    toggleFullScreen
  };
};
